import clsx from "clsx";
import { Link } from "gatsby";
import React from "react";

import * as styles from "./ArticleCard.module.scss";

const ArticleCard = ({ color, icon, groupTitle, guideDocs = [] }) => {
  return (
    <div className={clsx(styles.card, styles[color])}>
      <div className={styles.wrapper}>
        <div>
          <div className={styles.iconWrapper}>
            <img src={icon} alt="help-article" />
          </div>
          <Link to={`/da/guide/${guideDocs[0].uri}`} draggable={false}>
            <h6>{groupTitle}</h6>
          </Link>
        </div>
        <div className={styles.articleWrapper}>
          <ul className={styles.list}>
            {guideDocs.map(({ guideTitle, uri }) => (
              <li key={guideTitle}>
                <Link to={`/da/guide/${uri}`} draggable={false}>
                  {guideTitle}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={styles.count}>
        <span className={styles[color]}>{guideDocs.length}</span>
        <span>artikler</span>
      </div>
    </div>
  );
};

export default ArticleCard;
